import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ProjektServiceModule } from '..';
import { SavedProjektFiltersComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ProjektServiceModule
  ],
  declarations: [SavedProjektFiltersComponent],
  exports: [SavedProjektFiltersComponent],

})
export class SavedProjektFiltersComponentModule { }
